export const DEFAULT_USER_AUTH = { id: 0, email: '', token: null };
export const DEFAULT_PLAYER_AUTH = { id: 0, name: '', playerIdentifier: null };
